/* ════════════ THE CHECKLIST ════════════
   The start page's atmosphere: todo items scattered in the dark,
   ticking themselves off. Each one flashes green at [x], lingers,
   then respawns as a fresh [ ] somewhere else. Progress is ambient. */

import { onPage } from "./router";

const REDUCED = matchMedia("(prefers-reduced-motion: reduce)").matches;

const ITEMS = [
  "generate keys",
  "back up nsec",
  "write down seed",
  "install wallet",
  "test send",
  "withdraw to self-custody",
  "verify arrival",
  "pick a client",
  "add a signer",
  "post first note",
  "swap sats for xmr",
  "pay something in cash",
  "second paper copy",
  "move one friend",
  "follow the key",
  "run the drill",
];

function checklist(signal: AbortSignal) {
  const c = document.querySelector<HTMLCanvasElement>("#checklist")!;
  const ctx = c.getContext("2d")!;

  const GREEN = "#3ef08b";
  const GREY = "#9aa0a6";

  type Item = {
    x: number;
    y: number;
    label: string;
    wait: number; // frames until it ticks
    done: number; // frames spent ticked (then respawn)
    size: number;
    col: string;
  };
  let items: Item[] = [];

  const spawn = (): Item => ({
    x: Math.random() * c.width,
    y: Math.random() * c.height,
    label: ITEMS[(Math.random() * ITEMS.length) | 0]!,
    wait: 120 + ((Math.random() * 600) | 0),
    done: 0,
    size: 10 + Math.random() * 4,
    col: Math.random() < 0.2 ? GREEN : GREY,
  });

  const seed = () => {
    c.width = innerWidth;
    c.height = innerHeight;
    const count = Math.min(26, Math.floor((c.width * c.height) / 64000));
    items = Array.from({ length: count }, spawn);
  };
  seed();
  addEventListener("resize", seed, { signal });

  const draw = () => {
    ctx.clearRect(0, 0, c.width, c.height);
    for (const it of items) {
      const ticked = it.wait <= 0;
      if (ticked) {
        // freshly checked — glow green, fade out over the linger
        ctx.globalAlpha = Math.min(0.6, it.done < 30 ? 0.6 : 0.6 * (1 - (it.done - 30) / 150));
        ctx.fillStyle = GREEN;
      } else {
        ctx.globalAlpha = it.col === GREEN ? 0.35 : 0.16;
        ctx.fillStyle = it.col;
      }
      ctx.font = `${it.size}px "IBM Plex Mono", monospace`;
      ctx.fillText(`[${ticked ? "x" : " "}] ${it.label}`, it.x, it.y);
    }
    ctx.globalAlpha = 1;
  };

  if (REDUCED) {
    // static frame: a believable mid-session checklist
    for (const it of items) if (Math.random() < 0.4) it.wait = 0;
    draw();
    return;
  }
  const tick = () => {
    if (signal.aborted) return;
    for (let i = 0; i < items.length; i++) {
      const it = items[i]!;
      if (it.wait > 0) {
        it.wait--;
      } else if (++it.done >= 180) {
        items[i] = spawn();
      }
    }
    draw();
    requestAnimationFrame(tick);
  };
  tick();
}

onPage(checklist);
